import { render, staticRenderFns } from "./channelBussi.vue?vue&type=template&id=a73405b0&scoped=true&"
import script from "./channelBussi.vue?vue&type=script&lang=js&"
export * from "./channelBussi.vue?vue&type=script&lang=js&"
import style0 from "./channelBussi.vue?vue&type=style&index=0&id=a73405b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a73405b0",
  null
  
)

export default component.exports